import { UserRole } from "types/index";

export function isAdminRole(roleId?: number | null): boolean {
  return Number(roleId) === UserRole.ADMIN;
}

export function isCompanyRole(roleId?: number | null): boolean {
  return Number(roleId) === UserRole.COMPANY;
}

export function isIndividualRole(roleId?: number | null): boolean {
  return Number(roleId) === UserRole.INDIVIDUAL;
}

/** Company or Individual tenant (non-admin with a company account). */
export function isTenantRole(roleId?: number | null): boolean {
  return isCompanyRole(roleId) || isIndividualRole(roleId);
}

export function roleTypeLabel(
  roles?: number[] | null,
  roleId?: number | null
): string {
  const id = roleId ?? roles?.[0];
  if (isAdminRole(id)) return "Admin";
  if (isCompanyRole(id)) return "Company";
  if (isIndividualRole(id)) return "Individual";
  return "—";
}
